var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Pill,{attrs:{"variant":_setup.variant,"icon":_setup.icon,"label":_setup.label,"size":"sm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }